import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">FEATURED TOPICS</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">焦点专题</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站编辑精选的深度专题内容，一网打尽热门话题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 3 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 text-[10px] font-semibold px-2.5 py-1 rounded-full bg-primary-500 text-white">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-semibold text-foreground-900 mb-2 text-sm leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}